import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  FormControlComponent,
  PrimengButtonDirective,
  PrimengInputTextDirective,
} from '@web/shared/ui';
import { InputTextModule } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { Nillable } from '@web/utils';

type PublicBoxSearchPanelFormGroup = FormGroup<{
  phrase: FormControl<Nillable<string>>;
}>;

@Component({
  selector: 'app-public-box-search-panel',
  imports: [
    Button,
    FormControlComponent,
    InputTextModule,
    PrimengButtonDirective,
    PrimengInputTextDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './public-box-search-panel.component.html',
  styleUrl: './public-box-search-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxSearchPanelComponent {
  private readonly builder = inject(FormBuilder);

  public readonly phraseChangeEvent = output<Nillable<string>>();

  protected readonly form = this.buildForm();

  public handlePhraseChange(): void {
    const { phrase } = this.form.getRawValue();

    this.phraseChangeEvent.emit(phrase);
  }

  private buildForm(): PublicBoxSearchPanelFormGroup {
    return this.builder.group({
      phrase: this.builder.control<Nillable<string>>(null),
    });
  }
}
